import { sceneryTile as tile, type WorldBackdrop } from './worldShapeKit';

/** One woodland vocabulary, with different amounts of enclosure along the road.
 * These paths are built once; live frames only move the cached parallax layers. */
export const FOREST_JOURNEY_BACKDROPS = {
  forest_road: {
    far: tile('hills', [['fir', 160, 285, 180, 210], ['oak', 850, 285, 430, 245], ['fir', 1800, 300, 230, 250]]),
    mid: tile('banks', [['oak', 100, 325, 420, 310], ['fir', 1120, 322, 170, 240], ['oak', 1780, 335, 360, 300]]),
    near: tile('banks', [['reeds', 320, 314, 100, 60], ['snag', 1410, 330, 100, 130]]),
  },
  deep_woods: {
    far: tile('hills', [['fir', 140, 290, 230, 300], ['oak', 580, 310, 470, 300], ['fir', 1470, 297, 220, 280], ['oak', 1850, 320, 330, 280]]),
    mid: tile('banks', [['willow', 80, 330, 510, 360], ['oak', 1080, 338, 570, 350], ['snag', 2040, 330, 120, 240]]),
    near: tile('banks', [['reeds', 250, 311, 130, 76], ['snag', 1630, 330, 120, 155]]),
  },
  abandoned_camp: {
    far: tile('hills', [['fir', 210, 290, 220, 250], ['oak', 1260, 310, 470, 310], ['fir', 2100, 310, 170, 235]]),
    mid: tile('banks', [['gable', 180, 313, 255, 170], ['oak', 900, 329, 370, 300], ['gable', 1640, 330, 280, 190]]),
    near: tile('banks', [['reeds', 590, 320, 100, 55], ['snag', 1970, 334, 90, 110]]),
  },
  old_grove: {
    far: tile('hills', [['oak', 120, 310, 650, 340], ['oak', 1440, 320, 610, 330]]),
    mid: tile('banks', [['oak', 650, 345, 850, 395], ['snag', 1850, 330, 140, 220]]),
    near: tile('banks', [['reeds', 150, 310, 115, 66], ['reeds', 1630, 330, 150, 85]]),
  },
} satisfies Record<string, WorldBackdrop>;
